export default Object.freeze({
    LOCALE: 'da-DK',
});
